module.exports = __webpack_public_path__ + "static/media/0.726864d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shadow/0.png
// module id = 966
// module chunks = 0